import { APPLICATIONS } from "constants/common";

const getOriginApplication = () => {
  const userAgent = navigator.userAgent;
  if(userAgent.includes(APPLICATIONS.AIRTEL_WORK)) {
    return APPLICATIONS.AIRTEL_WORK;
  }
  return APPLICATIONS.BROWSER
};

export default getOriginApplication;
